import{jsx as e}from"react/jsx-runtime";import{styled as r}from"styled-components";import{MessageList as l}from"../styles/style.mjs";import{kebabCase as o}from"../../../../utils/StringUtils.mjs";const i=r.li`
  margin-left: 20px;
  color: #ee4400;
  list-style: url('images/warning_anim.png');

  span {
    cursor: pointer;
  }
`;function s({fieldErrors:r}){return e(l,{className:"field-error",children:r.map((({field:r,message:l},s)=>e(i,{onClick:()=>(e=>{var r;const l=document.querySelector(`#${e}`);null==l||l.focus(),l&&"select"in l&&l.select(),null===(r=null==l?void 0:l.querySelector(`[id^=${e}]`))||void 0===r||r.focus()})(o(r)),children:e("span",{children:l})},s)))})}export{s as FieldErrorList};
